type CraftEmailHrefArgs = {
	dmEmail: string;
	subject: string;
	body: string;
};

export const craftStarterEmail = ({ dmEmail, subject, body }: CraftEmailHrefArgs): string => {
	const ccChangeEmail = 'decision.makers@change.org';

	const encodedSubject = encodeURIComponent(subject);
	const encodedBody = encodeURIComponent(body);

	return `mailto:${dmEmail}?cc=${ccChangeEmail}&body=${encodedBody}&subject=${encodedSubject}`;
};
